import { createRoutine } from "../utils/routine.utils";
export var importPropertyPartnerWhise = createRoutine("PROPERTY_import_PARTNER_WHISE");
